var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pdf',{attrs:{"src":_vm.uri}})
}
var staticRenderFns = []

export { render, staticRenderFns }